import React from 'react'

function Thankyou() {
  return (
    <div className="thankyou">
        <div className="container-fluid p-5">
            <h1>Thank You We Will Get Back To You Shortly!</h1>
        </div>
    </div>
  )
}

export default Thankyou;